import AccionesClienteFinalCell from "@/components/AccionesTablas/ClienteFinal.acciones";
import CeldaSwitchActivo from "@/components/ui/CeldaSwitchActivoClientesFinales";
import type { ClienteFinal } from "@interfaces/user.interface";
import type { ColumnDef } from "@tanstack/react-table";
import {
  calcularTotalAprendicesUnicos,
  formatearFechaISOaDDMMYYYY,
} from "../utils";
import defaultLogo from "@/assets/default-logo.png";
import { LogoClienteFinal } from "@/components/ui/LogoClienteFinal";

export function getClienteFinalColumns(
  queryKey: ReadonlyArray<unknown>,
): ColumnDef<ClienteFinal>[] {
  return [
    {
      accessorKey: "empresa",
      header: "Empresa",
      cell: ({ row }) => {
        const empresa = row.original;
        return (
          <div className="flex items-center space-x-4">
            <LogoClienteFinal
              logoMarca={empresa.logoMarca}
              defaultSrc={defaultLogo}
              alt="Logo"
              className="w-30 h-20 rounded-md object-cover"
            />
            <div className="flex flex-col">
              <span className="font-medium">{empresa.nombreEmpresa}</span>
              <span className="text-sm text-muted-foreground">
                {empresa.usuario.correo}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "_count.programa",
      header: "Programas",
    },
    {
      header: "Aprendices",
      cell: ({ row }) => {
        const cliente = row.original;
        const totalAprendices = calcularTotalAprendicesUnicos(cliente);
        return <span>{totalAprendices}</span>;
      },
    },
    {
      accessorKey: "creadoEl",
      header: "Creado El",
      cell: ({ getValue }) => formatearFechaISOaDDMMYYYY(getValue() as string),
    },
    {
      accessorKey: "actualizadoEl",
      header: "Actualizado El",
      cell: ({ getValue }) => formatearFechaISOaDDMMYYYY(getValue() as string),
    },
    {
      accessorKey: "isActivo",
      header: "Activo",
      cell: ({ row }) => {
        const cliente = row.original;
        return <CeldaSwitchActivo clienteFinal={cliente} />;
      },
    },
    {
      id: "acciones",
      header: "Acciones",
      cell: ({ row }) => (
        <AccionesClienteFinalCell cliente={row.original} queryKey={queryKey} />
      ),
    },
  ];
}
